import { thanos26GetJson } from "./thanos26Client";

async function getAllTimeSafeOrganizations(): Promise<any> {
    return thanos26GetJson("TimeSafe/organizations");
}

export default { getAllTimeSafeOrganizations };
